import { Component, OnDestroy, OnInit, Input } from "@angular/core";
import { MessageService } from "./message.service";
import { Message } from "./message.model";
import { HttpResponse } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';
import { Router } from "@angular/router";
import { ChatSuggestionListsService } from "../../common/suggestion-lists/services/chat-suggestion-lists.service";
import { ReviewSuggestionListsService } from "../../common/suggestion-lists/services/review-suggestion-lists.service";

const SUGGESTION_CHAT = 'SL';
const STANDARD_CHAT = 'STND';
const SUGGESTION_DETAILS_ROUTE = 'suggestion-list-details';
const EXPIRED_SUGGESTION_ROUTE = 'ex-suggestion-expired';
const EMPTY_MESSAGE = '';

@Component({
  selector: "app-chat",
  templateUrl: "./chat.component.html",
  styleUrls: ["./chat.component.css"]
})
export class ChatComponent implements OnInit, OnDestroy {
  @Input() inWork = true;
  @Input() chat = false;
  isLoaded = false;
  chatName: string;
  chatMessages: Message[] = [];
  // отправляемое сообщение
  msg = "";
  errorMessage = false;
  chatVisible = true;
  chatUsingExperience = "";
  isSending = false;
  private subscriptions = new Subscription();

  constructor(
    public messageService: MessageService,
    public chatSuggestionListsService: ChatSuggestionListsService,
    public reviewSuggestionListsService: ReviewSuggestionListsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.isLoaded = false;
    if (this.router.url.includes(SUGGESTION_DETAILS_ROUTE) || this.router.url.includes(EXPIRED_SUGGESTION_ROUTE)) {
      this.chatUsingExperience = SUGGESTION_CHAT;
      this.loadSuggestionChat();
      return;
    }
    this.chatUsingExperience = STANDARD_CHAT;
    this.chatMessages = this.messageService.getMessages();
    this.messageService.readMessages();
    this.chatName = this.messageService.chatName;
    this.isLoaded = true;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private loadSuggestionChat() {
    this.chatSuggestionListsService.clearMessages();
    this.chatMessages = this.chatSuggestionListsService.getTempMsg();
    this.subscriptions.add(this.chatSuggestionListsService.getMessages().subscribe(
      (response: HttpResponse<{messages: Message[]}>) => {
        const messages = response.body && response.body.messages;
        this.chatMessages = messages ? messages.slice().reverse() : [];
        this.chatVisible = !this.chatMessages.length;
        this.chatSuggestionListsService.setMessages(this.chatMessages);
        this.errorMessage = false;
        this.isLoaded = true;
      },
      () => {
        this.isLoaded = true;
        this.errorMessage = true;
      }
    ));
  }

  changeVisibleChat() {
    this.chatVisible = this.chatVisible ? false : true;
  }

  doShowInputBlock() {
    if (this.chatUsingExperience === "STND") {
      return this.messageService.doShowInputBlock();
    } else if (this.chatUsingExperience === "SL") {
      return (
        this.reviewSuggestionListsService.getIsCurrentUserHead() ||
        this.reviewSuggestionListsService.getIsCurrentUserInitiator() ||
        this.reviewSuggestionListsService.getIsCurrentUserMember()
      );
    }
  }

  sendMessage() {
    if (!this.isLoaded || this.isSending || !this.msg.trim()) {
      return;
    }
    if (this.chatUsingExperience === SUGGESTION_CHAT) {
      this.sendSuggestionMessage();
      return;
    }
    this.messageService.addMessage(this.msg);
    this.msg = EMPTY_MESSAGE;
  }

  private sendSuggestionMessage() {
    this.isSending = true;
    this.errorMessage = false;
    this.subscriptions.add(this.chatSuggestionListsService.addMessage(this.msg).subscribe(
      () => {
        this.isSending = false;
        this.chatVisible = false;
        this.msg = EMPTY_MESSAGE;
      },
      () => {
        this.isSending = false;
        this.errorMessage = true;
      }
    ));
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/operating-standard/chat/chat.component.ts